import React, { useEffect, useState, useRef } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { useTheme, Modal, Box, Button, TextField, Checkbox, Snackbar, Alert, Dialog, DialogActions, DialogContent, DialogContentText } from '@mui/material';
import axios from 'axios'
import Pagination from "react-js-pagination";
import { TbLoader } from 'react-icons/tb';
import mainPath from '../../../utils/path';
import { MdOutlineRefresh } from "react-icons/md";

const useStyles = makeStyles((theme)=>({
  box:{
    maxWidth:'1800px',
    margin:'0 auto',
    padding:'0 20px',
  },
  oneToOneConfigBlockH1:{
    padding:'80px 0 0px 0px',
    fontWeight:'700',
    fontSize:'22px',
    display: 'flex'
  },
  load:{
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
  },
  loadingIcon:{
    color:'#007235',
    fontSize:'50px',
    animation:'$loadSpin 5s infinite'
  },
  "@keyframes loadSpin":{
    from: { transform:'rotate(0deg)' },
    to: { transform:'rotate(1turn)' }
  },
  datagridBox: {
    wordBreak:'break-all',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflowX: 'scroll',
    overflowY: 'hidden',
    border: '1px solid #D3D3D3',
  },
  datagridTop: {
    display: 'flex',
    border: '1px solid #D3D3D3',
    borderTop: 'none',
  },
  datagridTopItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #D3D3D3',
    borderTop:'none',
    borderBottom:'none',
    padding:'5px 0',

    [theme.breakpoints.down(557)]: {
      fontSize:'11px'
    },
  },
  contBox: {
    display: 'flex',
    alignItems: 'center',
  },
  contBoxItem: {
    textAlign:'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
    padding:'10px 0',

    [theme.breakpoints.down(557)]: {
      fontSize:'10px'
    },
  },
  checkBoxMain: {
    width: 50,
    height: '100%', 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center'
  },
  checkBoxItm: {
    width: '100%',
    height: '100%', 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center'
  },
  textLeft: {
    width: '100%', 
    height: '100%', 
    display: 'flex', 
    flexDirection: 'row', 
    justifyContent: 'center', 
  },
  textRight: {
    width: '100%', 
    height: '100%', 
    display: 'flex', 
    flexDirection: 'row', 
    justifyContent: 'center', 
    alignItems: 'center'
  },
  textMiddle: {
    width: '100%', 
    height: '100%', 
    display: 'flex', 
    flexDirection: 'row', 
    justifyContent: 'center', 
    alignItems: 'center'
  },
  imageText: {
    display: 'flex',
    alignItems: 'center'
  },
  modalBox: {
    width: 500,
    height: 300,
    backgroundColor: '#fff',
    borderRadius: 10,
    boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
  },
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalTextarea:{
    width:'95%',
    padding:'10px',
    margin:'10px',
    height:'100px'
  },
  modalBtn:{
    display:'flex',
    justifyContent:'center'
  },
  innerClass: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '15px',
    listStyle: 'none',
    padding: 0,
  },
  itemClass: {
      minWidth: '30px',
      border: '1px solid #e2e2e2',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '1rem',
  },
  itemClassFirst: {
      borderRadius: '15px 0 0 15px',
  },
  itemClassLast: {
      borderRadius: '0 15px 15px 0',
  },
  linkClass: {
      textDecoration: 'none',
      color: '#383A3F',
      fontSize: '1rem',
  },
  activeClass: {
      backgroundColor: '#383A3F'
  },
  activeLinkClass: {
      color: 'white',
  },
  appContent:{
    
  },
  spanSpan:{
    fontSize:'18px',
    fontWeight:'500',
    width:'250px',

    [theme.breakpoints.down(1025)]: {
      marginBottom:'10px',
      textAlign:'center',
    }
  },
  textareaDiv:{
    display:'flex',
    alignItems:'center',
    borderBottom:'1px solid #ddd',
    padding:'20px 0',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
    }
  },
  appContentFile:{    
    display:'flex',
    alignItems:'center',
    borderBottom:'1px solid #ddd',
    padding:'20px 0',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
    }
  },
  appContentInput:{
    width:'270px',
    height: '40px',
    padding:'0 0 0 8px',
    borderRadius:'3px',
    border:'1px solid #CCCCCC',
    '&:focus-within':{
      outline:'none'
    },

    [theme.breakpoints.down(1025)]: {
      margin:'10px 0'
    }

  },
  fileInput:{
    display: 'inline-block',
    padding: '.5em 1em',
    height: '40px',
    fontSize: '14px',
    backgroundColor: '#007235',
    color:'#fff',
    fontWeight:'600',
    cursor: 'pointer',
    borderRadius: '0px 3px 3px 0px',
    letterSpacing: '-0.7px',

    [theme.breakpoints.down(1025)]: {
      margin:'10px 0',
      height: '36px',
      borderRadius:'4px'
    },

    [theme.breakpoints.down(376)]: {
      fontSize: '12px',
    },

  },
  topBtn:{
    display:'flex',
    justifyContent:'end',
    paddingBottom:'20px',
  },
  firstBtn:{
    paddingBottom:'20px'
  },
  bottomDivTextarea:{
    width:'440px',
    height:'100px',

    [theme.breakpoints.down(1025)]: {
      width:'100%'
    },
  },
  textFieldDiv:{
    display:'flex',
    alignItems:'center',
    padding:'20px 0',
    borderBottom:'1px solid #ddd',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
    }
  },
  lastBtn:{
    padding:'20px 0',

    [theme.breakpoints.down(1025)]: {
      textAlign:'center'
    }

  },

}));


const OneToOneConfig = () => {
  const checkBox = true
  const [checks, setChecks] = useState([])
  const [allChecked, setAllChecked] = useState(false)
  const [page, setPage] = useState(1);
  const [pasings, setPasings] = useState(0);

  const [errSnack, setErrSnack] = useState(false);
  const [succSnack, setSuccSnack] = useState(false);

  const [recoCont, setRecoCont] = useState('')
  const [recoImg, setRecoImg] = useState('')
  const [itId, setItId] = useState('')

  const [modalOpen, setModalOpen] = useState(false)

  const [recoIdE, setRecoIdE] = useState(0)
  const [recoContE, setRecoContE] = useState('')
  const [itIdE, setItIdE] = useState('')

  const [loading, setLoading] = useState(false)

  const [delDial, setDelDial] = useState(false)

  const row = [
    {name: '내용', width: '40%'},
    {name: '날짜', width: '20%'},
    {name: '상품아이디', width: '20%'},
    {name: '관리', width: '20%'},
  ];

  const [data, setData] = useState([])

  const theme = useTheme();
  const classes = useStyles(theme);

  const imageInput = useRef();

  const onCickImageUpload = () => {
    imageInput.current.click();
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    return () => {
      setChecks([])
      setAllChecked(false)
      setPage(1)
      setPasings(0)
      setRecoCont('')
      setRecoImg('')
      setItId('')
      setRecoIdE(0)
      setRecoContE('')
      setItIdE('')
    }
  }, [])


  const getItems = async() => {
    
    try {
      setLoading(true)
      const res = await axios.post('/api/adm/getRecomands/', {page: page})

      if(res.data.success === false) {
        setErrSnack(true)
        setLoading(false)
        return ;
      }
      setData(res.data.result.reduce((result, item) => ([
        ...result, 
        [
        {id: item['reco_id'], data: item['reco_cont'], type: 'imageText', img: item['reco_img']},
        {id: item['reco_id'], data: item['reco_date'], type: 'textMiddle'},
        {id: item['reco_id'], data: item['it_id'], type: 'textMiddle'},
        {id: item['reco_id'], data: ['수정'], type: 'button'},
        ]
      ]), []))
      setPasings(res.data.itemCount)
      setLoading(false)
      
    } catch (e) {
      setErrSnack(true)
      setLoading(false)
      console.log(e)
    }
    
  }

  useEffect(() => {
    getItems()
    setChecks([])
    setAllChecked(false)

  } , [page])


  const handlePageChange = (page) => {
    setPage(page);
  };


  useEffect(() => {
    // 전체선택 관련 로직
    let allCheckList = []

    if(allChecked) {
      data.forEach(item => allCheckList.push(item[0].id));
      setChecks(allCheckList)
    } else {
      setChecks(allCheckList)
    }
    
  }, [allChecked])




  const delSelItems = async() => {
    if(checks.length >= data.length) return alert('최소 1개 추천아이템이 존재하여야 합니다.')

    let recoList = []
    checks.forEach((arrItem) => {
      data.forEach((dataItem) => {
        if(dataItem[0].id === arrItem){
          recoList.push({
            reco_id: dataItem[0].id,
          })
        } 
      })
    })


    try {
      const res = await axios.post('/api/adm/delRecomands/', {reco_list: recoList} )

      if(res.data.success === false){
        setErrSnack(true)
        console.log('실패')
        return ;
      }

      setSuccSnack(true)
      setChecks([])
      setAllChecked(false)
      setDelDial(false)
      getItems()
      
    } catch (e) {
      setErrSnack(true)
      console.log(e)
    }
  }


  const addItem = async() => {
    if (recoCont === '') return ;
    if (recoImg === '') return ;
    if (itId === '') return ;

    let formData = new FormData()

    formData.append("reco_cont", recoCont)
    formData.append("reco_img", recoImg)
    formData.append("it_id", itId)

    try {
      const res = await axios.post(
        '/api/adm/addRecomands/',
                            formData, 
                            {
                              headers: {
                                'Content-Type': 'multipart/form-data'
                              }
                            }
     )

      if (res.data.success === false) {
        setErrSnack(true)
      }
        setSuccSnack(true)
        getItems()
        setRecoCont('')
        setRecoImg('')
        setItId('')
  
    } catch (e) {
      setErrSnack(true)
      console.log(e)
    }

  }


  const editItems = async() => {

    try {
      const res = await axios.post(
        '/api/adm/editRecomands/', 
                      {
                        reco_id: recoIdE,
                        reco_cont: recoContE,
                        it_id: itIdE,
                      } )

      if(res.data.success === false){
        setErrSnack(true)
        console.log('실패')
        return ;
      }

      setSuccSnack(true)
      setModalOpen(false)
      setChecks([])
      setAllChecked(false)
      getItems()
      
    } catch (e) {
      setErrSnack(true)
      console.log(e)
    }
  }


  const snackClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setErrSnack(false);
    setSuccSnack(false)
  };

  return (
    <div className={classes.OneToOneConfigBlock}>
      <div className={classes.box}>
        <h1 className={classes.oneToOneConfigBlockH1}>
          팀장님 추천
          <div
              onClick={() => {
                getItems()
              }}
            style={{cursor:'pointer'}}
          >
            <MdOutlineRefresh/>
          </div>
        </h1>
        <div className={classes.topBtn}>
          <Button variant="outlined" onClick={() => checks.length > 0 && setDelDial(true)}>
            선택삭제
          </Button>
        </div>
        <div className={classes.datagridBox}>
          <div className={classes.datagridTop}>
            {checkBox && (
                <div className={classes.checkBoxMain}>
                  <Checkbox 
                    checked={allChecked}
                    onChange={e => setAllChecked(e.target.checked)}
                  />
                </div>
            )}
  
            {row.map((item, index) => (
                      <div key={index} className={classes.datagridTopItem} style={{width: item.width}}>
                        {item.name}
                      </div>
            ))}
          </div>
  
          {loading ? (
              <div className={classes.load}>
                <TbLoader className={classes.loadingIcon}/>
              </div>
            ) :
          data.length > 0 && data.map((dataItem, dataIndex) => {
            return(
                    <div 
                      key={dataIndex} 
                      className={classes.contBox}
                      style={{
                        backgroundColor: dataIndex % 2 == 0 && '#F2F2F2'
                      }}
                    >
                        {checkBox && (
                          <div className={classes.checkBoxMain}>
                            <Checkbox
                              checked={checks.includes(dataItem[0].id)}
                              onChange={() => !checks.includes(dataItem[0].id) ?
                                              setChecks([...checks, dataItem[0].id]) : 
                                              setChecks([...checks.filter((item) => item !==  dataItem[0].id)])
                                        }
                            />
                          </div>
                        )}
  
                        {dataItem.map((item, index) => {
                          return(
                                <div key={index} className={classes.contBoxItem} style={{width: row[index].width}}>
                                  {item.type === 'textMiddle' && (
                                    <h3 className={classes.textMiddle}>{item.data}</h3>
                                  )}
                                  {item.type === 'imageText' && (
                                    <div className={classes.imageText}>
                                      <img
                                        style={{width: 50, height: 50, marginRight: 5}}
                                        src={`${mainPath}/media/data/recomand/${item.img}`} 
                                      />
                                      <h3>{item.data.substr(0, 10)}....</h3>
                                    </div>
                                  )}
                                  {item.type === 'button' && 
                                    (
                                      <div style={{width: '100%', height: '100%'}}>
                                        {item.data.map((btnItm, btnIdx) => (
                                        <Button 
                                          key={btnIdx} 
                                          variant="text"
                                          onClick={() => {
                                            setRecoIdE(dataItem[0].id)
                                            setRecoContE(dataItem[0].data)
                                            setItIdE(dataItem[2].data)
                                            setModalOpen(true)
                                          }}
                                        >
                                          {btnItm}
                                        </Button>))}
                                      </div>
                                    )
                                  }
                           
  
  
                                </div>
                        )})}
                    </div>
          )})}
  
        </div>
  
        <Pagination
            activePage={page}
            itemsCountPerPage={15}
            totalItemsCount={pasings}
            pageRangeDisplayed={5}
            prevPageText={"‹"}
            nextPageText={"›"}
            onChange={handlePageChange}
            className={classes.navi}
            innerClass={classes.innerClass}    //안에?
            itemClass={classes.itemClass}      //아이템들?
            itemClassFirst={classes.itemClassFirst}    //first?
            itemClassLast={classes.itemClassLast}     // last
            linkClass={classes.linkClass}        // 아이템 링크
            activeClass={classes.activeClass}        // 현재페이지
            activeLinkClass={classes.activeLinkClass}     // 현제페이지 링크
        />
  
  
            <div className={classes.bottomDiv}>
              <div className={classes.firstBtn}>
                <Button variant="outlined" onClick={() => checks.length > 0 && setDelDial(true)}>
                  선택삭제
                </Button>
              </div>
    
              <div className={classes.textareaDiv}>
                <span className={classes.spanSpan}>내용</span>
                <textarea 
                  placeholder="내용을 입력해주세요."
                  value={recoCont}
                  onChange={(e) => setRecoCont(e.target.value)}
                  className={classes.bottomDivTextarea}
                />
              </div>
              <div className={classes.textFieldDiv}>
                <span className={classes.spanSpan}>상품코드</span>
                <TextField 
                  label="상품코드를 입력해주세요." 
                  variant="standard" 
                  value={itId}
                  onChange={(e) => setItId(e.target.value)}
                />
              </div>
              <div className={classes.appContentFile}>
                <span className={classes.spanSpan}>파일</span>
                <div className={classes.appContent}>
                  <input 
                    value={typeof(recoImg) === 'string' ? recoImg : recoImg.name}
                    type='text' 
                    className={classes.appContentInput} 
                    onChange={ (e) => {setRecoImg(e.target.value)}}
                  />
                </div>
                <div className={classes.fileDiv}>                
                    <input 
                      type="file" 
                      accept=".gif, .jpg, .jpeg, .png"
                      style={{ display: "none" }} 
                      ref={imageInput}
                      onChange={(e) => {
                        setRecoImg(e.target.files[0])
                      }}
                    />
                    <button 
                      onClick={onCickImageUpload}
                      className={classes.fileInput}                      
                    >
                      파일선택
                    </button>
                    
                  <Button     
                    variant="outlined"
                    onClick={() => {setRecoImg('')}}
                    style={{ margin:'0 0 0 10px'}}
                  >
                    이미지삭제
                  </Button>
                </div>
              </div>
    
              <div className={classes.lastBtn}>
                <Button 
                  variant="outlined" 
                  onClick={addItem}
                >
                  추가
                </Button>
              </div>
            </div>
  
  
  
  
          <Snackbar 
            open={errSnack} 
            autoHideDuration={6000} 
            onClose={snackClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
          >
            <Alert severity="error">수행을 실패 하였습니다!</Alert>
          </Snackbar>
          <Snackbar 
            open={succSnack} 
            autoHideDuration={6000} 
            onClose={snackClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
          >
            <Alert severity="success">수행을 성공 하였습니다!</Alert>
          </Snackbar> 

          <Dialog
            open={delDial}
            onClose={() => setDelDial(false)}
          >
            <DialogContent>
              <DialogContentText>
                정말 삭제 하시겠습니까?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setDelDial(false)}>아니오</Button>
              <Button onClick={() => delSelItems()}>네</Button>
            </DialogActions>
          </Dialog>

  
          <div className={classes.modalDiv}>
            <Modal
              open={modalOpen}
              onClose={() => {
                setModalOpen(false)
              }}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
              className={classes.modal}
            >
              <Box
                className={classes.modalBox}
              >
                <div>
                  <textarea 
                    placeholder="내용을 입력해주세요."
                    value={recoContE}
                    onChange={(e) => setRecoContE(e.target.value)}
                    className={classes.modalTextarea}
                  />
                </div>
                <div>
                  <TextField 
                    label="상품코드를 입력해주세요." 
                    variant="standard" 
                    value={itIdE}
                    onChange={(e) => setItIdE(e.target.value)}
                    style={{ margin:'20px 10px'}}  
                  />
                </div>
      
                <div className={classes.modalBtn}>
                  <Button
                    onClick={() => editItems()} 
                    style={{ background:'#007235', color:'#fff'}}
                  >
                    수정
                  </Button>
                </div> 
              </Box>
            </Modal>
          </div>

      </div> 
    </div>
  )
}

export default OneToOneConfig
